/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_CloseInputs */

const en_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const th_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิด`)
};

const ja_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const ru_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const zh_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const vi_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Chat_CloseInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_close = /** @type {((inputs?: Chat_CloseInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_CloseInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_close(inputs)
	if (locale === "ja") return ja_chat_close(inputs)
	if (locale === "fr") return fr_chat_close(inputs)
	if (locale === "es") return es_chat_close(inputs)
	if (locale === "ru") return ru_chat_close(inputs)
	if (locale === "zh") return zh_chat_close(inputs)
	if (locale === "vi") return vi_chat_close(inputs)
	return en_chat_close(inputs)
});